import styled from 'styled-components';
import Button from 'components/Button';

export const CheckoutContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

export const Title = styled.div`
    width: 100%;
    text-align: center;
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 100%;
    margin-bottom: 20px;
    color: #D6E1EF;
    opacity: 0.8;
`;

export const PayButton = styled(Button)`
    min-width: 200px;
    height: 40px;
    border-radius: 400px;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    color: #D6E1EF;
    opacity: 0.9;
    margin: auto;
    margin-bottom: 10px;
    background: linear-gradient(90.25deg, #128C7E -21.19%, #25D366 126.2%);
    &:hover{
        opacity: 1;
    }
    &:active{
        opacity: 1;
    }
    @media only screen and (max-width: 768px) {
        margin-top: 5px;
        flex-shrink: 0;
        margin-top: 10px;
    }
`;

export const PayButtonMessenger = styled(Button)`
    min-width: 200px;
    height: 40px;
    border-radius: 400px;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    color: #D6E1EF;
    opacity: 0.9;
    margin: auto;
    margin-bottom: 10px;
    background: linear-gradient(90.25deg, #006AFF -21.19%, #00B2FF 126.2%);
    &:hover{
        opacity: 1;
    }
    &:active{
        opacity: 1;
    }
    @media only screen and (max-width: 768px) {
        margin-top: 5px;
        flex-shrink: 0;
        margin-top: 10px;
    }
`;

export const PayButtonTelegram = styled(Button)`
    min-width: 200px;
    height: 40px;
    border-radius: 400px;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    color: #D6E1EF;
    opacity: 0.9;
    margin: auto;
    margin-bottom: 10px;
    background: #0088cc;
    &:hover{
        opacity: 1;
    }
    &:active{
        opacity: 1;
    }
    @media only screen and (max-width: 768px) {
        margin-top: 5px;
        flex-shrink: 0;
        margin-top: 10px;
    }
`;

export const OrText = styled.div`
    width:100%;
    height: 20px;
    font-size: 12px;
    font-family: Roboto;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
`;

export const ModalTitle = styled.div`
    font-family: Khula;
    font-style: normal;
    font-weight: 700;
    font-size: 50px;
    line-height: 100%;
    display: flex;
    align-items: center;
    color: #D6E1EF;
    opacity: 0.8;
    border-bottom: 30px solid transparent;
    @media only screen and (max-width: 768px) {
        font-family: Khula;
        font-style: normal;
        font-weight: 800;
        font-size: 35px;
        line-height: 100%;
        display: flex;
        align-items: center;
        text-align: center;
        color: #D6E1EF;
        opacity: 0.8;
    }
`;

export const ModalContent = styled.div`
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 25px;
    line-height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    color: #D6E1EF;
    opacity: 0.8;
    margin-bottom: 20px;
    @media only screen and (max-width: 768px) {
        font-family: Khula;
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        color: #D6E1EF;
    }
`;